(function () {
    'use strict';

    angular.module("imApp").factory("accountingAllocationService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3771,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3772,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3777,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
